import { ISnotrRoute } from '..';

export default [
  {
    path: '/payment-methods',
    name: 'PaymentMethods',
    meta: {
      title: 'TabTitle.paymentMethods',
      applicationMode: 'InvoicingMode',
    },
    component: () => import('@/pages/payment-methods.vue'),
  },
] as ISnotrRoute[];
